import './style/index.css';
import App from './components/app';

declare global {
    interface Window { digitalData: any; }
}
export default App;
